import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=18bf1123&scoped=true"
import script from "./videoList.vue?vue&type=script&lang=js"
export * from "./videoList.vue?vue&type=script&lang=js"
import style0 from "./videoList.vue?vue&type=style&index=0&id=18bf1123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf1123",
  null
  
)

export default component.exports